export const environment = {
  Logging: {
    IsFirebase: true,
    LogLevel: "Warn"
  },
  // Prod firebase

  firebase: {
    projectId: 'realtimetrac-48416',
    appId: '1:511883410480:web:1f3c55eba43fb1cde141f5',
    storageBucket: 'realtimetrac-48416.appspot.com',
    apiKey: 'AIzaSyCzzjbLrQVh4tDlTje3hbkf1qPnXJ9QnTc',
    authDomain: 'realtimetrac-48416.firebaseapp.com',
    messagingSenderId: '511883410480',
    measurementId: 'G-TF5Z0SJ142',
    vapidKey: 'BLnv7a068wOip89QJmGE-i-D2afhuiG1gICk-pWRCS9B_ShtoeL_gk5LEQ2NP0sjMPe8NsEkQWdVL4l0eAahZu4'
  },

  /** This firebase can be used to fetch dev env drivers and locations */

  // firebase: {
  //   apiKey: "AIzaSyBvdb2AWUSQe8hfXuknR8gxbVikTag1cWM",
  //   authDomain: "realtimetrac-d56d2.firebaseapp.com",
  //   projectId: "realtimetrac-d56d2",
  //   storageBucket: "realtimetrac-d56d2.appspot.com",
  //   messagingSenderId: "870218375217",
  //   appId: "1:870218375217:web:2cf92fca9d7e27744a3510",
  //   measurementId: "G-9JEZ3VR5WB",
  //   vapidKey:'BBN_8W_S4fkRwDwuywzs_LSMn7lCiPaYbWzOyex26jzn87UODh3up0IJvABoMAyo9Ifc5FPPzzST0IpSvDtBHLQ'
  // },


  port: 8090,
  production: false,
  apiUrl: 'https://admin.smilewithsangeeta.com:8090', // Dev Url
  domain: 'https://admin.smilewithsangeeta.com',      // dev domain
  appVersion: '1.0.8',
  stripeKey: 'pk_test_51OI3lgSGmsmXN9Ul6KUMGH0Vbm4T3joNWKTlTs0uq25gu5TuCZ9S2GOVcePAXxBhAqId4tbs4lNmLL70XZ8dWwMW00DCVt3gPa',
  trackingSessionTimeoutMs: 30 * 60 * 1000, // 30 minutes
};

